{
  const getValueFromJSON = require('../utils/getValueFromJSON');
  const { get, set } = require('../utils/getterSetter');
  const evaluate = require('../utils/evaluate');

  // ### Returns the errors associated with a field path on the actual context.
  //
  // This is a utility method for helpers and should NOT be called directly
  function getFieldErrors(path, options) {
    const errors = options.data.errors || {};
    let message;
    const fieldPrefix = options.data.modelAttribute ? `${options.data.modelAttribute}.` : '';
    const realPath = fieldPrefix + path;
    let index;

    if (!errors.errorsHash) {
      // initialize the short cut errors map
      errors.errorsHash = {};

      if (errors.fieldMessages) {
        for (index = 0; index < errors.fieldMessages.length; index++) {
          message = errors.fieldMessages[index];
          errors.errorsHash[message.fieldName] = message;
        }
      }
    }

    return errors.errorsHash[realPath];
  }

  // parse values from path strings to create valid ids.
  function getIdFromPath(path) {
    return path.replace(/\[\s*|\s*\]/g, '');
  }

  // ### Returns a string with all attributes to be used by the helpers
  // ## Example using:
  //    joinAttributes(attrs)
  function joinAttributes(attrs) {
    let attrsString = '';

    Object.keys(attrs).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(attrs, key)) {
        attrsString += `${key}="${attrs[key]}" `;
      }
    });

    // ensuring space before/after just in case someone call it without adding the spaces
    return ` ${attrsString}`;
  }

  module.exports = {
    evaluate,

    get,
    set,

    getValueFromJSON,

    getIdFromPath,

    getFieldErrors,

    joinAttributes,
  };
}
